export default "__VITE_ASSET__D7zB9gg3__"